module.exports = __webpack_public_path__ + "static/p1-9743f7c106358de9b6b7ffdc9c40f9ff.jpg";